<template>
<div class="mb-3">
    <div class="d-flex align-center">
        <v-avatar
            color="grey lighten-3"
            class="me-2 align-self-start"
            size="40">
            <!-- <v-img src="https://randomuser.me/api/portraits/women/33.jpg"></v-img> -->
            <v-icon>mdi-account</v-icon>
        </v-avatar>
        <div>
            <div class="font-weight-bold primary--text">{{comment.created_by}}</div>
            <div class="text-caption">{{formatTimestamp(comment.created_at)}}</div>
            <div class="text-body-2">{{comment.comment}}</div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';

export default {
    name: "CustomerActivityDisplayCommentItem",
    props: {
        comment: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatTimestamp(timestamp) {
            return moment(timestamp).format("YYYY-MM-DD HH:MM");
        },
    }
}
</script>
